import classnames from 'classnames';
import React, { forwardRef, ReactNode, Ref } from 'react';

import { Button, StandardButtonTypes, SmallButtonTypes, ButtonSizes } from '@eika/button';
import { CheckmarkAnimation } from '@eika/checkmark-animation';

import './style.scss';

type BasicButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export interface ButtonWithSpinnerProps extends BasicButtonProps {
    ariaLabel?: string;
    // @default 'positive'
    buttonType?: StandardButtonTypes | SmallButtonTypes;
    // @default 'standard'
    size?: ButtonSizes;
    children: ReactNode;
    className?: string;
    disabled?: boolean;
    showSpinner?: boolean;
    showSuccess?: boolean;
}

function wrapIfText(children: ReactNode) {
    if (typeof children === 'string') {
        return <span>{children}</span>;
    }
    return children;
}

const ButtonWithSpinner = forwardRef(
    (
        {
            ariaLabel = 'Vent litt',
            children,
            className,
            disabled,
            showSpinner,
            showSuccess,
            ...rest
        }: ButtonWithSpinnerProps,
        ref: Ref<HTMLButtonElement>,
    ): JSX.Element => {
        const showStatus = showSpinner || showSuccess;
        return (
            <Button
                className={classnames('sgw-button-with-spinner', className, {
                    'show-spinner': showSpinner && !showSuccess,
                    'show-success': showSuccess,
                })}
                disabled={showStatus || disabled}
                {...rest}
                role={showStatus ? 'status' : undefined}
                ref={ref}
            >
                <span role="alert">{showStatus && <span className="screen-reader-text">{ariaLabel}</span>}</span>
                {!showStatus && wrapIfText(children)}
                {showSuccess && <CheckmarkAnimation className="sgw-button-with-spinner__checkmark" />}
            </Button>
        );
    },
);

export default ButtonWithSpinner;
